export function loginErrorKey(error) {
  const code = error.response?.data?.error?.code
  const status = error.response?.status
  if (code === 'EMAIL_NOT_VERIFIED') return 'auth.login.email_not_verified_description'
  if (code === 'AUTH_INVALID_CREDENTIALS') return 'auth.login.invalid_credentials'
  if (status === 429) return 'auth.login.rate_limited'
  if (status === 419) return 'auth.login.session_expired'
  return 'auth.login.unavailable'
}
